import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { generarReciboCarrito } from '../Carrito/reciboCarrito';

const API_PAGA = 'https://centrocomunicar.com/api-comunicar/endpoints/recursos_paga.php';

export default function PagoExitoso() {
  const [params] = useSearchParams();
  const codigo   = params.get('pedido');
  const metodo   = params.get('metodo') || 'culqi';

  const [pedidoData, setPedidoData] = useState(null);
  const [loading,    setLoading]    = useState(true);
  const [descargando,setDescargando]= useState(false);

  useEffect(() => {
    if (!codigo) { setLoading(false); return; }
    const fetchPedido = async () => {
      try {
        const tkn = localStorage.getItem('com_token');
        const headers = tkn ? { 'Authorization': `Bearer ${tkn}` } : {};
        const r = await fetch(`${API_PAGA}?action=detalle_pedido&codigo=${encodeURIComponent(codigo)}`, { headers });
        const j = await r.json();
        if (j.success) setPedidoData(j.data);
      } catch (e) {
        // silencioso — igual se muestra la pantalla de éxito
      } finally {
        setLoading(false);
      }
    };
    fetchPedido();
  }, [codigo]);

  const descargarRecibo = () => {
    if (!pedidoData) return;
    setDescargando(true);
    try {
      generarReciboCarrito({
        pedido:        { codigo: pedidoData.codigo },
        items:         pedidoData.items,
        form:          { nombre: pedidoData.nombre, email: pedidoData.email },
        metodo:        pedidoData.metodo_pago || metodo,
        descuento:     pedidoData.descuento_puntos || 0,
        cuponAplicado: pedidoData.puntos_usados > 0 ? { codigo: 'PUNTOS' } : null,
        totalFinal:    pedidoData.monto,
      });
    } finally {
      setDescargando(false);
    }
  };

  return (
    <div style={{
      minHeight:'100vh', background:'#f3f8f5',
      display:'flex', alignItems:'center', justifyContent:'center',
      fontFamily:'"DM Sans",sans-serif', padding:'2rem'
    }}>
      <div style={{
        background:'#fff', borderRadius:20, padding:'3rem 2.5rem',
        maxWidth:480, width:'100%', textAlign:'center',
        boxShadow:'0 8px 40px rgba(130,216,179,.2)'
      }}>
        <div style={{
          width:72, height:72, background:'#d1fae5', borderRadius:'50%',
          display:'flex', alignItems:'center', justifyContent:'center',
          margin:'0 auto 1.5rem', fontSize:'2rem'
        }}>✓</div>
        <h1 style={{fontFamily:'"Cormorant Garamond",serif',fontSize:'1.8rem',color:'#111614',marginBottom:'.8rem'}}>
          ¡Pago exitoso!
        </h1>
        <p style={{color:'#5a6a63',fontSize:'.95rem',lineHeight:1.7,marginBottom:'1.5rem'}}>
          Tu pago fue procesado correctamente. Tu acceso al recurso ha sido activado — puedes descargarlo desde tu cuenta.
        </p>
        <div style={{background:'#edfaf4',borderRadius:12,padding:'1rem',marginBottom:'1.2rem',fontSize:'.85rem',color:'#4db88a',fontWeight:600}}>
          🏆 También acumulaste puntos por esta compra. Revísalos en <strong>Mis puntos</strong>.
        </div>

        {/* Descargar recibo */}
        {codigo && (
          <button
            onClick={descargarRecibo}
            disabled={loading || !pedidoData || descargando}
            style={{
              display:'inline-flex', alignItems:'center', gap:'.4rem',
              background:'transparent', color:'#111614', border:'1.5px solid #d4f4e8',
              fontWeight:700, padding:'.7rem 1.6rem', borderRadius:100,
              fontSize:'.85rem', cursor: loading||!pedidoData ? 'default' : 'pointer',
              marginBottom:'1.2rem', opacity: loading||!pedidoData ? .6 : 1,
            }}
          >
            🧾 {loading ? 'Cargando recibo…' : descargando ? 'Generando…' : 'Descargar recibo'}
          </button>
        )}
        <br/>

        <Link to="/mi-cuenta" style={{
          display:'inline-block', background:'#111614', color:'#fff',
          fontWeight:700, padding:'.9rem 2rem', borderRadius:100,
          textDecoration:'none', fontSize:'.95rem'
        }}>
          Ir a Mis recursos →
        </Link>
        <br/>
        <Link to="/" style={{display:'inline-block',marginTop:'1rem',color:'#5a6a63',fontSize:'.85rem'}}>
          Volver al inicio
        </Link>
      </div>
    </div>
  );
}